import { combineReducers } from "redux"

import Layout from "./layout/reducer"
import Header from "./layout/header/reducer"
import Login from "./auth/login/reducer"
import Inbox from "./inbox/reducer";
import Files from "./files/reducer";
import Slip from "./slip/reducer";
import Invoice from "./invoice/reducer";
import Companies from "./companies/reducer";
import AnalyticalAccounts from "./companies/analyticalAccounts/reducer";
import Sections from "./sections/reducer";
import Segments from "./segments/reducer";
import Users from "./users/reducer";
import UserPermissions from "./users/permissions/reducer";
import Groups from "./groups/reducer";
import GroupPermissions from "./groups/permissions/reducer";
import EnumPermissions from "./enums/permissions/reducer";
import EnumVersions from "./enums/versions/reducer";
import EnumStorages from "./enums/storages/reducer";
import SelectModal from "./components/selectModal/reducer";
import SmartDropzone from "./components/smartDropzone/reducer";
import Notifications from "./notifications/reducer";
import ConfirmModal from "./components/confirmModal/reducer";
import Search from "./search/reducer";
import GraphModal from "./components/graphModal/reducer";
import SimpleFiles from "./simpleFiles/reducer";
import NotificationDropdown from "./layout/notificationDropdown/reducer"
import UserNotificationsModal from "./userNotificationsModal/reducer";
import Dashboard from "./dashboard/reducer";

const rootReducer = combineReducers({
  Layout,
  Header,
  Login,
  Inbox,
  Files,
  Slip,
  Invoice,
  Companies,
  AnalyticalAccounts,
  Sections,
  Segments,
  Users,
  UserPermissions,
  Groups,
  GroupPermissions,
  EnumPermissions,
  EnumVersions,
  EnumStorages,
  SelectModal,
  SmartDropzone,
  Notifications,
  ConfirmModal,
  Search,
  GraphModal,
  SimpleFiles,
  NotificationDropdown,
  UserNotificationsModal,
  Dashboard,
})

export default rootReducer
